export const NODE_TYPES = {
  section: "section",
  sectionsummarygroup: "sectionsummarygroup",
  questionGroup: "questionGroup",
  subquestiongroup: "subquestiongroup",
  question: "question",
};
export const FIELD_TYPES: any = {
  textbox: "textbox",
  multitextbox: "multitextbox",
  boolean: "boolean",
  dropdown: "dropdown",
  singleselect: "singleselect",
  multiselect: "multiselect",
  datetime: "datetime",
  monthyear: "monthyear",
  text: "text",
  listtext: "listtext",
  formbutton: "formbutton",
};
export const VALIDATION_TYPES: any = { length: "length", regex: "regex" };
export const BOXICON_OPTIONS: any = {
  Analytics: "Analytics",
  Bag: "Bag",
  Checklist: "Checklist",
  Commando: "Commando",
  Congratulations: "Congratulations",
  congratulation: "congratulation",
  Cup: "Cup",
  Donate: "Donate",
  Family: "Family",
  Find: "Find",
  Headphone: "Headphone",
  Kite: "Kite",
  Magnifier: "Magnifier",
  Medical: "Medical",
  Money: "Money",
  Network: "Network",
  NoPdf: "NoPdf",
  Notepad: "Notepad",
  Passport: "Passport",
  Report: "Report",
  Sad: "Sad",
  Survey: "Survey",
  Task: "Task",
  Team: "Team",
  Toure: "Toure",
  Upload: "Upload",
};
export const ICON_OPTIONS: any = {
  personal: "personal",
  immigration: "immigration",
  financials: "financials",
  disclaimer: "disclaimer",
  employment: "employment",
  eligibility: "eligibility",
  miscllaneous: "miscllaneous",
  familymarriage: "familymarriage",
  Evidence: "Evidence",
  medical: "medical",
  Pay: "Pay",
  Print: "Print",
};
